import Client from './Clients/AxiosClient'
const prodiResource = '/api/v1/admin/prodi'
const statsResource = '/api/v1/admin/prodi-stats'
const peminatResource = '/api/v1/admin/prodi-peminat'

export default {
  getProdi(prodiId) {
    return Client.get(`${prodiResource}/${prodiId}`)
  },
  getStats(prodiId) {
    return Client.get(`${statsResource}/prodi/${prodiId}`)
  },
  createStats(payload) {
    return Client.post(statsResource, payload)
  },
  updateStats(payload, id) {
    return Client.put(`${statsResource}/${id}`, payload)
  },
  deleteStats(id) {
    return Client.delete(`${statsResource}/${id}`)
  },
  getPeminat(prodiId) {
    return Client.get(`${peminatResource}/prodi/${prodiId}`)
  },
  createPeminat(payload) {
    return Client.post(peminatResource, payload)
  },
  updatePeminat(payload, id) {
    return Client.put(`${peminatResource}/${id}`, payload)
  },
  deletePeminat(id) {
    return Client.delete(`${peminatResource}/${id}`)
  },
}
